import { useEffect, useMemo, useState } from 'react'
import { Table, Select, Space, Input, Button, DatePicker, Form, Modal, Row, Col } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import baseAxios, { baseAxiosNoInfo, axiosTable, baseAxiosComplete } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import { SelectStores } from '../../component/common/Selects'
import { DeleteButton } from "../../component/common/Buttons"
import { formItemLayout, tailLayout } from '../../js/globalParam'
import getPermission from '../../js/permission'
import moment from 'moment'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type pagination = {
  current: number,
  pageSize: number,
  total: number,
}

type fetchParams = {
  store_id: string | undefined,
  customer_name: string | undefined,
  customer_phone: string | undefined,
  item_name: string | undefined,
  inDate: any,
  employee_id_recover: string | undefined,
  employee_id_teacher: string | undefined
}

type formDataTml = {
  consume_id: string | undefined,
  customer_name: string | undefined,
  customer_phone: string | undefined,
  order_source_type_desc: string | undefined,
  item_name: string | undefined,
  service_start_time: string | undefined,
  employee_name_adviser: string | undefined,
  employee_name_recover: string | undefined,
  manual_cost_amount: string | undefined,
  settlement_amount: string | undefined,
  service_date: string | undefined,
  new_order_source_type: string | undefined,
  new_employee_id_adviser: string | undefined,
  new_employee_name_adviser: string | undefined,
  new_employee_id_recover: string | undefined,
  new_employee_name_recover: string | undefined,
  new_employee_id_teacher: string | undefined,
  new_employee_name_teacher: string | undefined,
  new_consume_manual_cost: string | undefined,
  new_settlement_amount: string | undefined
}

export default function CkConsumeList() {

  let otherParamsTml = {
    store_id: undefined,
    customer_name: undefined,
    customer_phone: undefined,
    item_name: undefined,
    inDate: undefined,
    employee_id_recover: undefined,
    employee_id_teacher: undefined
  }

  let paginatioTml = {
    current: 1,
    pageSize: 8,
    total: 0
  }

  let formDatas = {
    consume_id: undefined,
    customer_name: undefined,
    customer_phone: undefined,
    order_source_type_desc: undefined,
    item_name: undefined,
    service_start_time: undefined,
    employee_name_adviser: undefined,
    employee_name_recover: undefined,
    manual_cost_amount: undefined,
    settlement_amount: undefined,
    service_date: undefined,
    new_order_source_type: undefined,
    new_employee_id_adviser: undefined,
    new_employee_name_adviser: undefined,
    new_employee_id_recover: undefined,
    new_employee_name_recover: undefined,
    new_employee_id_teacher: undefined,
    new_employee_name_teacher: undefined,
    new_consume_manual_cost: undefined,
    new_settlement_amount: undefined
  }

  const [initDate, setInitDate] = useState<boolean>(true)

  const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)
  const [pagination, setPagination] = useState<pagination>(paginatioTml)

  const [adviserEmployeeList, setAdviserEmployeeList] = useState<any[]>([])
  const [recoverEmployeeList, setRecoverEmployeeList] = useState<any[]>([])
  const [teacherEmployeeList, setTeacherEmployeeList] = useState<any[]>([])
  const [editAdviserList, setEditAdviserList] = useState<any[]>([])
  const [editRecoverList, setEditRecoverList] = useState<any[]>([])
  const [editTeacherList, setEditTeacherList] = useState<any[]>([])

  const [tableList, setTableList] = useState<any[]>([])

  const [editVisible, setEditVisible] = useState<boolean>(false)
  const [formData, setFormData] = useState<formDataTml>(formDatas)
  const [consumeRef] = Form.useForm()

  const permission: string[] = useMemo(() => {
    return getPermission()
  }, [window.location.pathname])

  useEffect(() => {
    if (initDate) {
      var startDate = moment().startOf('month');
      var endDate = moment().endOf('month');
      // 初始化创建日期
      otherParams.inDate = [startDate, endDate];

      setInitDate(false)
    }

    fetch({ pagination, otherParams })
  }, [pagination.current])

  const getEmployeeList = (id: any) => {
    // 查询产康顾问
    baseAxiosNoInfo('/global/employee_list_by_position', {
      params: {
        department_id: id,
        position_number: 4
      }

    }).then((res: any) => {
      if (res) {
        setAdviserEmployeeList(res)
      }
    })

    // 查询产康师列表
    baseAxiosNoInfo('/global/employee_list_by_position', {
      params: {
        department_id: id,
        position_number: 5
      }

    }).then((res: any) => {
      if (res) {
        setRecoverEmployeeList(res)
      }
    })

    // 查看产康老师列表
    baseAxiosNoInfo('/global/employee_list_by_position', {
      params: {
        department_id: id,
        position_number: 28
      }

    }).then((res: any) => {
      if (res) {
        setTeacherEmployeeList(res)
      }
    })
  }

  const handleInputChange = (value: string, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSelectChange = (value: string, attr: string) => {
    if (attr == 'store_id') {
      getEmployeeList(value)
    }

    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleChange = (value: any, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setInitDate(false)
    setOtherParams(params)
  }

  const handleDate = (param: any, attr: string, realDateParams: string[]) => {
    if (param[attr]) {
      param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
      param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

      delete param[attr]
    }
  }

  const handleSelectModChange = (value: string, attr: string) => {
    let params: any = _.cloneDeep(formData)
    params[attr] = value

    setFormData(params)
  }

  const handleSelectChangeEmployee = (value: string, attr: string, type: string) => {
    let params: any = _.cloneDeep(formData)

    if (type === 'adviser') {
      params['new_employee_id_adviser'] = value.split("&")[0]
      params['new_employee_name_adviser'] = value.split("&")[1]

    } else if (type === 'recover') {
      params['new_employee_id_recover'] = value.split("&")[0]
      params['new_employee_name_recover'] = value.split("&")[1]

    } else if (type === 'teacher') {
      params['new_employee_id_teacher'] = value.split("&")[0]
      params['new_employee_name_teacher'] = value.split("&")[1]
    }

    setFormData(params)
  }

  const handleSearch = () => {
    fetch({ pagination, otherParams })
  }

  const handleTableChange = (antPagination: any) => {
    const p = { ...pagination }
    p.current = antPagination.current

    setPagination(p)
  }

  const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }
    // 处理日期参数
    handleDate(params, 'inDate', ['service_start_time', 'service_end_time'])

    axiosTable.get('/chankang_center/item_consume/page_list', {
      params: {
        ...iPagination,
        ...params
      }

    }).then((response: any) => {
      if (response) {
        let p: any = { ...pagination }
        p.total = response.total

        setPagination(p)
        setTableList(response.records)
      }
    })
  }

  const exportExcel = () => {
    const iPagination: any = { ...pagination }

    let params: any = { ...otherParams }
    // 处理日期参数
    handleDate(params, 'inDate', ['service_start_time', 'service_end_time'])

    baseAxiosComplete('/chankang_center/item_consume/export', {
      params: {
        ...iPagination,
        ...params
      }

    }).then(res => {
      if (res.status === 0) {
        window.open(res.data)
      }
    })
  }

  const resetForm = () => {
    setInitDate(false)
    setOtherParams(otherParamsTml)

    let p: any = { ...pagination }
    p.current = 1

    setPagination(p)
    fetch({ pagination: p, otherParams: otherParamsTml })
  }

  const handleEdit = (record: any) => {
    // 初始化表单数据
    consumeRef.setFieldsValue({
      service_date: undefined,
      new_order_source_type: undefined,
      new_employee_id_adviser: undefined,
      new_employee_name_adviser: undefined,
      new_employee_id_recover: undefined,
      new_employee_name_recover: undefined,
      new_employee_id_teacher: undefined,
      new_employee_name_teacher: undefined,
      new_consume_manual_cost: undefined,
      new_settlement_amount: undefined,
    })

    let params: any = _.cloneDeep(formData)
    params['consume_id'] = record.consume_id
    params['customer_name'] = record.customer_name
    params['customer_phone'] = record.customer_phone
    params['order_source_type'] = record.order_source_type
    params['order_source_type_desc'] = record.order_source_type_desc
    params['item_name'] = record.item_name
    params['service_start_time'] = record.service_start_time
    params['employee_name_adviser'] = record.employee_name_adviser
    params['employee_name_recover'] = record.employee_name_recover
    params['manual_cost_amount'] = record.manual_cost_amount
    params['settlement_amount'] = record.settlement_amount

    params['new_order_source_type'] = ''
    params['new_employee_id_adviser'] = ''
    params['new_employee_name_adviser'] = ''
    params['new_employee_id_recover'] = ''
    params['new_employee_name_recover'] = ''
    params['new_employee_id_teacher'] = ''
    params['new_employee_name_teacher'] = ''
    params['new_consume_manual_cost'] = ''
    params['new_settlement_amount'] = ''
    setFormData(params)

    baseAxiosNoInfo('/global/employee_list_by_position', {
      params: {
        department_id: record.store_id,
        position_number: 4
      }

    }).then((res: any) => {
      if (res) {
        setEditAdviserList(res)
      }
    })

    baseAxiosNoInfo('/global/employee_list_by_position', {
      params: {
        department_id: record.store_id,
        position_number: 5
      }

    }).then((res: any) => {
      if (res) {
        setEditRecoverList(res)
      }
    })

    baseAxiosNoInfo('/global/employee_list_by_position', {
      params: {
        department_id: record.store_id,
        position_number: 28
      }

    }).then((res: any) => {
      if (res) {
        setEditTeacherList(res)
      }
    })

    setEditVisible(true)
  }

  // 关闭弹框
  const changeCancel = () => {
    setEditVisible(false)
  }

  // 提交编辑
  const confirmEdit = (value: any) => {
    let data = {
      consume_id: formData.consume_id,
      service_date: value.service_date ? value.service_date.format('YYYY-MM-DD') : '',
      order_source_type: formData.new_order_source_type,
      employee_id_adviser: formData.new_employee_id_adviser,
      employee_name_adviser: formData.new_employee_name_adviser,
      employee_id_recover: formData.new_employee_id_recover,
      employee_name_recover: formData.new_employee_name_recover,
      employee_id_teacher: formData.new_employee_id_teacher,
      employee_name_teacher: formData.new_employee_name_teacher,
      consume_manual_cost: value.new_consume_manual_cost ? value.new_consume_manual_cost : '',
      consume_settlement_amount: value.new_settlement_amount ? value.new_settlement_amount : ''
    }

    baseAxios.post('/chankang_center/item_consume/update', { ...data }).then((res: any) => {
      fetch({ pagination, otherParams })
      setEditVisible(false)
    })
  }

  const getAdviserEmployeeList = adviserEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id} >{el.user_name}</Option>))
  const getRecoverEmployeeList = recoverEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id} >{el.user_name}</Option>))
  const getTeacherEmployeeList = teacherEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id} >{el.user_name}</Option>))
  const getEditAdviserList = editAdviserList.map((el: any) => (<Option value={el.employee_id + '&' + el.user_name} key={el.employee_id} >{el.user_name}</Option>))
  const getEditRecoverList = editRecoverList.map((el: any) => (<Option value={el.employee_id + '&' + el.user_name} key={el.employee_id} >{el.user_name}</Option>))
  const getEditTeacherList = editTeacherList.map((el: any) => (<Option value={el.employee_id + '&' + el.user_name} key={el.employee_id} >{el.user_name}</Option>))

  return <div className="common-page">
    {/* 产康中心 -> 产康客户管理 -> 产康消耗列表 */}
    <BreadCrumb position={['产康中心', '产康消耗列表']} />

    <div className="common-top-form">
      <Space direction="horizontal" wrap>
        <div style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectStores valueProp="id" value={otherParams.store_id} onChange={(value: string) => { handleSelectChange(value, 'store_id') }} />
        </div>

        <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_name} placeholder="客户名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_name') }} />
        <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_phone} placeholder="客户手机号" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_phone') }} />
        <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} value={otherParams.item_name} placeholder="项目名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'item_name') }} />

        <RangePicker style={{ marginRight: 8, marginBottom: 12, width: '250px' }} className="fl" placeholder={["服务开始日期", "服务结束日期"]} value={otherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
        <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={otherParams.employee_id_recover} onChange={(value: string) => { handleSelectChange(value, 'employee_id_adviser') }} placeholder="产康顾问">
          {getAdviserEmployeeList}
        </Select>
        <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} value={otherParams.employee_id_recover} onChange={(value: string) => { handleSelectChange(value, 'employee_id_recover') }} placeholder="产康师">
          {getRecoverEmployeeList}
        </Select>
        <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 130 }} value={otherParams.employee_id_teacher} onChange={(value: string) => { handleSelectChange(value, 'employee_id_teacher') }} placeholder="产康老师">
          {getTeacherEmployeeList}
        </Select>
      </Space>

      <div style={{ marginTop: 10 }}>
        {permission.includes('查询') && <Button className="search-btn" style={{ marginRight: 12, marginBottom: 12 }} icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
        <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
        {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>}
      </div>
    </div>

    <div className="common-main">
      <Table dataSource={tableList} scroll={{ x: 'max-content' }} bordered={true} rowKey="consume_id" pagination={pagination} onChange={handleTableChange}>
        <Column fixed title="操作" key="action" render={(text, record: any) => (
          <Space size="middle">
            <Button size="small" type="primary" onClick={() => handleEdit(record)}>编辑</Button>
            <DeleteButton url="/chankang_center/item_consume/delete" record={record} cb={handleSearch}>删除</DeleteButton>
          </Space>
        )} />

        <Column title="门店" dataIndex="store_name" key="store_name" />
        <Column title="客户名称" dataIndex="customer_name" key="customer_name" />
        <Column title="客户手机号" dataIndex="customer_phone" key="customer_phone" />
        <Column title="入住状态" dataIndex="check_in_status_desc" key="check_in_status_desc" />
        <Column title="入住信息" dataIndex="room_number" key="room_number" />
        <Column title="项目名称" dataIndex="item_name" key="item_name" />
        <Column title="服务日期" dataIndex="service_start_time" key="service_start_time" />
        <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
        <Column title="产康师" dataIndex="employee_name_recover" key="employee_name_recover" />
        <Column title="产康老师" dataIndex="employee_name_teacher" key="employee_name_teacher" />
        <Column title="手工费" dataIndex="manual_cost_amount" key="manual_cost_amount" />
        <Column title="结转金额" dataIndex="settlement_amount" key="settlement_amount" />
        <Column title="服务状态" dataIndex="service_status_desc" key="service_status_desc" />
        <Column title="创建时间" dataIndex="create_time" key="create_time" />
      </Table>
    </div>

    <Modal title="编辑产康消耗" visible={editVisible} onCancel={changeCancel} footer={false} width="500px">
      <Form {...formItemLayout} form={consumeRef} onFinish={confirmEdit} >
        <Row gutter={16} style={{ marginLeft: 10, marginBottom: 10 }}>
          <Col span={10}>
            <div>客户姓名：{formData.customer_name}</div>
          </Col>
          <Col span={10}>
            <div>客户手机号：{formData.customer_phone}</div>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginLeft: 10, marginBottom: 10 }}>
          <Col span={10}>
            <div>服务日期：{formData.service_start_time}</div>
          </Col>
          <Col span={10}>
            <div>项目类型：{formData.order_source_type_desc}</div>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginLeft: 10, marginBottom: 10 }}>
          <Col span={24}>
            <div>服务项目：{formData.item_name}</div>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginLeft: 10, marginBottom: 10 }}>
          <Col span={10}>
            <div>产康顾问：{formData.employee_name_adviser}</div>
          </Col>
          <Col span={10}>
            <div>产康师：{formData.employee_name_recover}</div>
          </Col>
        </Row>

        <Row gutter={16} style={{ marginLeft: 10, marginBottom: 20 }}>
          <Col span={10}>
            <div>结转金额：{formData.settlement_amount}</div>
          </Col>
          <Col span={10}>
            <div>手工费：{formData.manual_cost_amount}</div>
          </Col>
        </Row>

        <Form.Item label="新日期" name="service_date">
          <DatePicker placeholder="不选则默认原日期" style={{ width: 200 }} />
        </Form.Item>

        <Form.Item label="新项目类型" name="new_order_source_type" >
          <Select placeholder="不选则默认原项目类型" onChange={(value: string) => { handleSelectModChange(value, 'new_order_source_type') }}>
            <Option value="1" key="1">产康购买</Option>
            <Option value="2" key="2">产康赠送</Option>
            <Option value="3" key="3">月子额外赠送</Option>
            <Option value="4" key="4">月子套餐赠送</Option>
          </Select>
        </Form.Item>

        <Form.Item label="新产康顾问" name="new_employee_id_adviser">
          <Select style={{ width: 200 }} value={formData.new_employee_id_adviser} showSearch
            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
            onChange={(value: string, option: any) => { handleSelectChangeEmployee(value, option, 'adviser') }}
            placeholder="不选则默认原产康顾问">
            {getEditAdviserList}
          </Select>
        </Form.Item>

        <Form.Item label="新产康师" name="new_employee_id_recover">
          <Select style={{ width: 200 }} value={formData.new_employee_id_recover} showSearch
            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
            onChange={(value: string, option: any) => { handleSelectChangeEmployee(value, option, 'recover') }}
            placeholder="不选则默认原产康师">
            {getEditRecoverList}
          </Select>
        </Form.Item>

        <Form.Item label="新产康老师" name="new_employee_id_teacher">
          <Select style={{ width: 200 }} value={formData.new_employee_id_teacher} showSearch
            filterOption={(input, option) => (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase())}
            onChange={(value: string, option: any) => { handleSelectChangeEmployee(value, option, 'teacher') }}
            placeholder="不选则默认原产康老师">
            {getEditTeacherList}
          </Select>
        </Form.Item>

        <Form.Item label="新手工费" name="new_consume_manual_cost" >
          <Input placeholder="不填则默认原手工费" style={{ width: 200 }} />
        </Form.Item>

        <Form.Item label="新结转金额" name="new_settlement_amount" >
          <Input placeholder="不填则默认原结转金额" style={{ width: 200 }} />
        </Form.Item>

        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">提交</Button>
        </Form.Item>
      </Form>
    </Modal>
  </div>
}